import React from 'react';
import PropTypes from 'prop-types';

const GroupTitle = (props) => {
  const { text, children } = props;

  return (
    <div className="groupTitle">
      <div>{text}</div>
      {children}
    </div>
  );

};

GroupTitle.defaultProps = {
  text: '',
};

GroupTitle.propTypes = {
  text: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default GroupTitle;
